import { Formik } from "formik";
import { useState } from "react";
import Loader from "../../components/loader";
import Eye from "../../components/forms/Eye";
import AuthLayout from "../../layout/AuthLayout";
import { webPaths } from "../../routes/pageRoutes";
import { useDispatch, useSelector } from "react-redux";
import { changePasswordSchema } from "../../utils/schema";
import useCountry from "../../components/hooks/useCountry";
import { useLocation, useNavigate } from "react-router-dom";
import ErrorMessage from "../../components/forms/ErrorMessage";
import { resetCurrentPassword } from "../../redux/actions/authAction";
import { buildAuthModalState } from "../../routes/authModal";

const ResetPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const countryData = useCountry();
  const [isEye1, setIsEye1] = useState(false);
  const [isEye2, setIsEye2] = useState(false);
  const identifier = useLocation()?.state?.identifier || "";
  const { isLoading } = useSelector((state) => state.authReducer);
  const initialValues = {
    new_password: "",
    confirm_password: "",
  };

  const handleChangePassword = (values) => {
    const callback = (res) => {
      if (res?.success) {
        navigate(webPaths?.Login, {
          state: buildAuthModalState(location),
        });
      }
    };
    const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(identifier);
    const payload = {
      password: values?.new_password,
      ...(isEmail
        ? { email: identifier }
        : { phone_no: `${countryData?.country_calling_code}${identifier}` }),
    };

    dispatch(
      resetCurrentPassword({
        payload,
        callback,
      }),
    );
  };

  if (isLoading) {
    return <Loader />;
  }
  return (
    <>
      <AuthLayout>
        <div class="col-lg-12 mx-auto  login-popup__left ct_custom_scroll">
          <div>
            <div class="login-popup__brand mb-4">
              <img
                onClick={() => {
                  navigate(webPaths?.WebHome);
                }}
                style={{ cursor: "pointer" }}
                src="/assets/img/logo_black.png"
                class="main-logo"
                alt="SecurPoint"
              />
            </div>

            <h5 class="login-popup__title mb-2 ct_fs_28 text-center">
              Set Up Your Security
            </h5>
            <p class="ct_fs_15 ct_fw_500 text-center opacity-50 ct_switzer_medium">
              Create a password to protect your account
            </p>
          </div>
          <Formik
            initialValues={initialValues}
            validationSchema={changePasswordSchema}
            onSubmit={(values, actions) => {
              handleChangePassword(values);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
            }) => (
              <form className="mt-5">
                <div class="login-popup__roles">
                  <div class="">
                    <label class="mt-3 ct_fs_16 ct_fw_400 mb-2">Password</label>

                    <div class="position-relative">
                      <input
                        type={isEye1 ? "text" : "password"}
                        placeholder="Enter password"
                        class="form-control ct_input ct_input_pe_40 ct_login_input"
                        id="new_password"
                        value={values.new_password}
                        onBlur={handleBlur}
                        onChange={handleChange}
                      />
                      <Eye isEye={isEye1} onClick={() => setIsEye1(!isEye1)} />
                    </div>
                    <ErrorMessage
                      errors={errors}
                      touched={touched}
                      fieldName="new_password"
                    />
                    <span class="ct_text_red mt-2 d-none">
                      Please Enter Confirm Password
                    </span>
                  </div>

                  <div class="">
                    <label class="mt-3 ct_fs_16 ct_fw_400 mb-2">
                      Confirm Password
                    </label>

                    <div class="position-relative">
                      <input
                        type={isEye2 ? "text" : "password"}
                        placeholder="Enter confirm password"
                        class="form-control ct_input ct_input_pe_40 ct_login_input"
                        id="confirm_password"
                        value={values?.confirm_password}
                        onBlur={handleBlur}
                        onChange={handleChange}
                      />
                      <Eye isEye={isEye2} onClick={() => setIsEye2(!isEye2)} />
                    </div>
                    <ErrorMessage
                      errors={errors}
                      touched={touched}
                      fieldName="confirm_password"
                    />
                    <span class="ct_text_red mt-2 d-none">
                      Please Enter Confirm Password
                    </span>
                  </div>
                </div>

                <button
                  onClick={(e) => {
                    e.preventDefault();
                    // navigate(webPaths?.Login);
                    handleSubmit();
                  }}
                  class="btn mt-4 ct_green_bnt ct_white_nowrap w-100"
                >
                  Submit
                </button>

                <p class="ct_fs_15 ct_fw_500 mt-3 text-center">
                  Already Know Your Password?
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(webPaths?.Login, {
                        state: buildAuthModalState(location),
                      });
                    }}
                    class="ct_fs_15 ct_fw_600 ct_green_text ct_cursor_pointer"
                  >
                    {" "}
                    Sign in
                  </a>
                </p>
              </form>
            )}
          </Formik>
        </div>
      </AuthLayout>
    </>
  );
};

export default ResetPassword;
